// extracted by mini-css-extract-plugin
export default {"riskLevel":"RiskLevel_riskLevel__cYIC3","label":"RiskLevel_label__9Lupb"};